import React from "react";

import { TextLinksContent } from "./TextLinksContent";
import { Socials } from "./Socials";
import { NounGazetteSubscription } from "./NounGazetteSubscription";

import Flexbox from "core/Flexbox";
import { Row, Col } from "core/grid";
import colors from "core/colors";
import {
    Footer,
    SiteFooterWrapper,
    SiteFooterGrid,
    CopyrightBar,
    NounProjectLogo,
    DesktopTextLinks,
    DesktopTextLinksCol,
    TabletMobileTextLinks,
    HomeLink
} from "./styles";

const SiteFooter = () => {
    return (
        <Footer id="site-footer" data-testid="site-footer">
            <SiteFooterWrapper fullWidth>
                <SiteFooterGrid>
                    <Row between="xs" top="md">
                        <Col sm={12} md={6} lg={3}>
                            <HomeLink href="/" alt="Home">
                                <NounProjectLogo
                                    title="Noun Project Logo"
                                    fillColor={colors.mist}
                                />
                            </HomeLink>
                            <Socials />
                        </Col>
                        <DesktopTextLinksCol sm={false} lg={6}>
                            <DesktopTextLinks>
                                <TextLinksContent />
                            </DesktopTextLinks>
                        </DesktopTextLinksCol>
                        <Col sm={12} md={6} lg={3}>
                            <Flexbox justifyContent="flex-end">
                                <NounGazetteSubscription />
                            </Flexbox>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <TabletMobileTextLinks>
                                <TextLinksContent />
                            </TabletMobileTextLinks>
                        </Col>
                    </Row>
                </SiteFooterGrid>
            </SiteFooterWrapper>
            <CopyrightBar fullWidth>© Noun Project Inc.</CopyrightBar>
        </Footer>
    );
};

export default SiteFooter;
